<template>
  <v-container>
    <v-row v-if="orderrItemGroup != null">
      <!-- levy panel s hlavnim obsahem -->
      <v-col class="col-12 col-md-8">
        <subject-profile
          v-if="shouldBeVisible"
          :subjectProfile="orderrItemGroup.subjectProfile"
          :rentProductTypes="rentProductTypes"
          :shouldBeVisible="shouldBeVisible"
          :shouldBeRequired="shouldBeRequired"
          @change="subjectProfileChangeHandler"
        ></subject-profile>

        <v-row v-if="orderrItemGroup.product">
          <v-col class="col-12 my-4">
            <!-- prvni orderrItem reprezentuje hlavni produkt i v pripadnem kompletu -->
            <rent-orderr-item
              :product="orderrItemGroup.orderrItems[0].product"
              :orderr-item="orderrItemGroup.orderrItems[0]"
              :orderr-item-group="orderrItemGroup"
              :key="orderrItemGroup.orderrItems[0].product.title"
              @change="orderrItemChange"
            >
            </rent-orderr-item>
          </v-col>
        </v-row>

        <template v-if="orderrItemGroup.product">
          <rent-set
            v-for="(item, index) in orderrItemGroup.product.sets.items"
            :key="item.set.id"
            :set="item"
            :setIndex="index + 1"
            :orderr-item-group="orderrItemGroup"
            :orderr-items="orderrItemGroup.orderrItems"
            @setChange="setChange"
            @orderrItemChange="orderrItemChange"
          >
          </rent-set>
        </template>

        <div v-else>Produkt nebyl nalezen</div>

        <div v-for="item in $store.state.articlesBySize" :key="item.id">
          <span>{{ item.title }} {{ item.id }} {{ item.size }}</span>
        </div>
      </v-col>

      <!-- pravy panel s rekapitulaci polozky -->
      <v-col class="col-12 col-md-4">
        <v-card>
          <div v-if="orderrItemGroup.product">
            <v-card-text class="d-none d-md-block">
              Příprava rezervace
            </v-card-text>

            <v-card-title class="display-1">{{
              orderrItemGroup.product.title
            }}</v-card-title>

            <v-card-text>
              <p>
                Pobočka (půjčovna):<br />
                <span class="font-weight-black subtitle-1">
                  {{ pointSell.title }}
                </span>
              </p>

              <p>
                Termín zápůjčky:<br />
                <span class="font-weight-black subtitle-1">
                  {{ dateStartFormated }} - {{ dateEndFormated }}
                </span>
              </p>

              <p>
                Délka zápůjčky:<br />
                <span class="font-weight-black subtitle-1">
                  {{ orderrItemGroup.length }} dny
                </span>
              </p>

              <v-divider></v-divider>

              <price-summary
                :price="orderrItemGroupPrice"
                :deposit="deposit"
              ></price-summary>
            </v-card-text>
            <v-card-actions>
              <v-btn
                block
                class="primary"
                :loading="submiting"
                :disabled="
                  !orderrItemGroupValid ||
                  currentOrderrExpired ||
                  (shouldBeRequired && orderrItemGroup.subjectProfile == null)
                "
                @click="bookItem"
              >
                Do košíku</v-btn
              >
            </v-card-actions>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- notifikace - polozka pridana do kosiku -->
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="550">
        <v-card>
          <v-card-title class="headline">
            <v-icon color="green"> mdi-checkbox-marked </v-icon>
            Položka byla přidána do košíku
          </v-card-title>
          <v-card-text
            >Na dokončení rezervace máte
            {{ mobConfig.checkoutTimeLimit }} minut.</v-card-text
          >
          <v-card-actions>
            <v-btn @click="goToRentSearch" text> Pokračovat </v-btn>
            <v-btn @click="goToCart" text> Košík </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { API, graphqlOperation } from "aws-amplify";
import { getProduct } from "../graphql/mob_queries";
import { getSet } from "../graphql/mob_queries";
import RentOrderrItem from "@/components/RentOrderrItem";
import PriceSummary from "@/components/PriceSummary";
import RentSet from "@/components/RentSet";
import SubjectProfile from "@/components/SubjectProfile";
import PriceCalculator from "@/libs/PriceCalculator";
import moment from "moment";

export default {
  metaInfo: {
    title: "Rezervace",
  },

  components: {
    RentOrderrItem,
    SubjectProfile,
    RentSet,
    PriceSummary,
  },

  data() {
    return {
      orderrItemGroup: null,

      // pomocna promenna pro vyvolani reaktivity. Nastavuje se na konci metody this.setChange(index).
      // Vyuziva se computed: rentProductTypes()
      rentSetIndex: 0,
      dialog: false,
      submiting: false,
    };
  },

  computed: {
    mobConfig() {
      return this.$store.state.mobConfig;
    },

    currentOrderrExpired() {
      return this.$store.state.currentOrderrExpired;
    },

    productId() {
      console.log("computed - productID");

      return this.$route.params.productId;
    },

    dateStartFormated() {
      return moment(this.orderrItemGroup.dateStart).format("D. M. YYYY");
    },

    dateEndFormated() {
      return moment(this.orderrItemGroup.dateEnd).format("D. M. YYYY");
    },

    pointSell() {
      return this.$store.state.pointSell;
    },

    orderrItemGroupValid() {
      if (this.orderrItemGroup.product == null) {
        return false;
      }

      if (this.orderrItemGroup == null) {
        return false;
      }

      // if (this.orderrItemGroup.subjectProfile == null) {
      //   return false;
      // }

      // if (this.orderrItemGroup.subjectProfile.name == null || this.orderrItemGroup.subjectProfile.name == "") {
      //   return false;
      // }

      if (
        this.orderrItemGroup.orderrItems == null ||
        this.orderrItemGroup.orderrItems.length == 0
      ) {
        return false;
      }

      let orderrItemsValid = true;
      for (let i = 0; i < this.orderrItemGroup.orderrItems.length; i++) {
        orderrItemsValid =
          orderrItemsValid &&
          this.orderrItemGroup.orderrItems[i].article != null;
      }

      return orderrItemsValid;
    },

    orderrItemGroupPrice() {
      return PriceCalculator.calculatePriceOrderrItemGroup(
        this.orderrItemGroup,
        this.mobConfig.rentDiscountPercent
      );
    },

    deposit() {
      return this.orderrItemGroup.product.deposit;
    },

    rentProductTypes() {
      console.log("rentProductTypes");

      let types = [];
      let k = this.rentSetIndex; // pomocna promenna pro vyvolani reaktivity. Nastavuje se na konci metody this.setChange(index)
      console.log(k);
      for (let i = 0; i < this.orderrItemGroup.orderrItems.length; i++) {
        console.log(i);

        let oi = this.orderrItemGroup.orderrItems[i];
        console.log(oi);
        if (oi.product.rentProductType != null) {
          types.push(oi.product.rentProductType);
        }
      }
      console.log(types);
      return types;
    },

    rentProductRequirements() {
      return this.$store.state.rentProductRequirements;
    },

    shouldBeVisible() {
      console.log("shouldBeVisible");
      let isVisible = false;
      for (let i = 0; i < this.rentProductTypes.length; i++) {
        let type = this.rentProductTypes[i];
        console.log("i: " + i);
        console.log(type);
        for (let j = 0; j < this.rentProductRequirements.length; j++) {
          let req = this.rentProductRequirements[j];
          console.log("j: " + j);
          console.log(req);
          if (type == req.rentProductType) {
            isVisible =
              isVisible ||
              req.nameDisplayed ||
              req.sexDisplayed ||
              req.ageDisplayed ||
              req.weightDisplayed ||
              req.heightDisplayed ||
              req.shoeSizeDisplayed ||
              req.rentAbilityLevelDisplayed;
          }
        }
      }
      return isVisible;
    },

    shouldBeRequired() {
      let isRequired = false;
      for (let i = 0; i < this.rentProductTypes.length; i++) {
        let type = this.rentProductTypes[i];
        for (let j = 0; j < this.rentProductRequirements.length; j++) {
          let req = this.rentProductRequirements[j];
          if (type == req.rentProductType) {
            isRequired =
              isRequired ||
              req.nameRequired ||
              req.sexRequired ||
              req.ageRequired ||
              req.weightRequired ||
              req.heightRequired ||
              req.shoeSizeRequired ||
              req.rentAbilityLevelRequired;
          }
        }
      }
      return isRequired;
    },
  },

  async mounted() {
    console.log("mounted");

    if (
      this.$store.state.pointSell == null ||
      this.$store.state.appInstance == null ||
      this.$store.state.checkInDate == null ||
      this.$store.state.checkOutDate == null
    ) {
      console.log("Nesplnene prerekvizity");
      this.$router.push({ name: "rent" });
    } else {
      this.init();
    }
  },

  methods: {
    async init() {
      if (this.productId == null) {
        throw "Product ID is NULL";
      }

      const result = await API.graphql(
        graphqlOperation(getProduct, {
          id: this.productId,
        })
      );
      let rentProduct = result.data.getProduct;
      console.log("rentProduct");
      console.log(rentProduct);

      let oi = {
        product: rentProduct,
        article: null,
      };

      let subjectProfile = null;

      let oig = {
        location: this.$store.state.pointSell.location,
        dateStart: this.$store.state.checkInDate,
        dateEnd: this.$store.state.checkOutDate,
        itemsCount: 1,
        numberOfPersons: 1,
        priceListType: "DAILY",
        length:
          moment(this.$store.state.checkOutDate).diff(
            this.$store.state.checkInDate,
            "days"
          ) + 1,
        price: 0,
        dph: 0,
        dphPercent: 0,
        subjectProfile: subjectProfile,
        product: rentProduct, // hlavni produkt
        set: null, // indikator setu
        orderrItems: [oi],
      };

      this.orderrItemGroup = oig;
    },

    async setChange(setIndex) {
      console.log("set cahnge");
      console.log(setIndex);

      let orderrItems = [];
      // do vysledne kolekce orderrItems jde vzdy prvni orderr item, ktery jiz existuje -- ridici produkt
      orderrItems.push(this.orderrItemGroup.orderrItems[0]);

      // set s indexem 0 = zadny set
      if (setIndex == 0) {
        // dealokovat zabookovane zdroje
        this.orderrItemGroup.set = null;
      }
      // set s indexem > 0 je nejaky skutecny set
      // index je vsak posunuty o 1 pozici
      else if (setIndex > 0) {
        let setItem = this.orderrItemGroup.product.sets.items[setIndex - 1];

        console.log(setItem);

        // console.log(setItem.set);

        const result = await API.graphql(
          graphqlOperation(getSet, {
            id: setItem.set.id,
          })
        );
        console.log(result);
        this.orderrItemGroup.set = result.data.getSet;

        // iterace pres vsechny polozky setu -- neexistujici orderrItem zalozit
        console.log(this.orderrItemGroup.set.products.items.length);
        for (
          let i = 0;
          i < this.orderrItemGroup.set.products.items.length;
          i++
        ) {
          var product = this.orderrItemGroup.set.products.items[i].product;
          let oiExists = false;
          for (let j = 0; j < this.orderrItemGroup.orderrItems.length; j++) {
            let oi = this.orderrItemGroup.orderrItems[j];

            if (product.id == oi.product.id) {
              oiExists = true;
            }
          }

          if (!oiExists) {
            let newOrderrItem = {
              product: product,
              article: null,
              location: null,
              itemsCount: 1,
              length:
                moment(this.checkOutDate).diff(this.checkInDate, "days") + 1,
              price: 0,
              dph: 0,
              dphPercent: 0,
            };

            orderrItems.push(newOrderrItem);
          }
        }
      }

      this.orderrItemGroup.orderrItems = orderrItems;
      this.rentSetIndex = setIndex;
    },

    /**
     * reaguje na zmenu polozky objednavky a propisuje tuto zmenu do OrderrItemGroup
     */
    orderrItemChange(changedOrderrItem) {
      console.log(changedOrderrItem);
      // ulozit orderrItem do orderItemGroup
      let orderrItems = [];
      for (let i = 0; i < this.orderrItemGroup.orderrItems.length; i++) {
        let oi = this.orderrItemGroup.orderrItems[i];
        // if(oi == null || oi.product == null || changedOrderrItem == null || changedOrderrItem.product == null) {
        //   console.log("neco je nulllllll");
        //   console.log("oi" + oi);
        //   console.log("oi.product" + oi.product);
        //   console.log("changedOrderrItem" + changedOrderrItem);
        //   console.log("changedOrderrItem.product" + changedOrderrItem.product);
        // }
        if (
          changedOrderrItem.product != null &&
          oi.product.id == changedOrderrItem.product.id
        ) {
          orderrItems.push(changedOrderrItem);
        } else {
          orderrItems.push(oi);
        }
      }
      this.orderrItemGroup.orderrItems = orderrItems;
    },

    async bookItem() {
      this.submiting = true;
      console.log("zarezervuj polozku");

      await this.$store.dispatch("addToCart", this.orderrItemGroup);

      this.submiting = false;

      // notifikace
      // nabidnout prejit do kosiku nebo dale vybirat
      this.dialog = true;
    },

    goToCart() {
      this.dialog = false;
      this.$router.push({ name: "cart" });
    },

    goToRentSearch() {
      this.dialog = false;
      this.$router.push({ name: "rent-search" });
    },

    editItem() {},

    subjectProfileChangeHandler(subjectProfile) {
      this.orderrItemGroup.subjectProfile = subjectProfile;
    },
  },

  //
};
</script>
